import styled from '@emotion/styled'
import { tone, ui } from '../../../utils/uiTokens'

export const styles = {
    error: {
        color: tone.bad.text,
        marginLeft: 2,
    },
}

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`
export const TotalSum = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`
export const TotalInfoBox = styled.div`
    font-size: 18px;
    color: ${ui.ink};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px;
    background: ${ui.track};
    border: 1px solid ${ui.border};
    border-radius: 8px;
`
export const TotalInfoText = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
`
export const DateWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`
export const ComponentsWrapper = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`
export const SearchStyles = {
    boxContainer: {
        margin: '10px',
        borderRadius: '16px',
    },
    filterBox: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 2,
    },
    searchBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    search: {
        width: '440px',
    },
}

export const error = {
    color: tone.bad.text,
    marginLeft: 2,
}
export const iconButton = {
    background: ui.track,
    mr: 2,
}
export const activeIconButton = {
    background: tone.ok.bg,
    mr: 2,
}

export const boxHeight = {
    height: '100px',
}
